import styled from '@emotion/styled';
import SpeechRecognition from 'react-speech-recognition';
import { config } from '@/config';
import { useAppSelector } from '@/store';

export function DiagnosticsScreen() {

  const hasRTCPeerConnection = !!window.RTCPeerConnection;
  const hasGetUserMedia = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  const hasDataChannel = hasRTCPeerConnection && 'createDataChannel' in new RTCPeerConnection();

  const features = useAppSelector(state => state.features);

  return (
    <Root>
      <Wrap>
        <Table>
          <Label>APP_ENVIRONMENT</Label><Value>{config().APP_ENVIRONMENT}</Value>
          <Label>APP_PLATFORM</Label><Value>{config().APP_PLATFORM}</Value>
          <Label>BRAND_INSIGHTS_API_URL</Label><Value>{config().BRAND_INSIGHTS_API_URL}</Value>
          <Label>DEMO_ENV</Label><Value>{config().DEMO_ENV ? 'True' : 'False'}</Value>
          <Label>FRONT_BASE_URL</Label><Value>{config().FRONT_BASE_URL}</Value>
          <Label>SENTRY_ENABLED</Label><Value>{config().SENTRY_ENABLED ? 'True' : 'False'}</Value>
          <Label>SENTRY_DSN</Label><Value>{config().SENTRY_DSN}</Value>
          <Label>STT_SUPPORTED</Label><Value>{SpeechRecognition.browserSupportsSpeechRecognition() ? 'True' : 'False'}</Value>
          <Label>ORIGIN</Label><Value>{window.location.origin}</Value>
          <Label>RTCPeerConnection</Label><Value>{hasRTCPeerConnection ? 'True' : 'False'}</Value>
          <Label>getUserMedia</Label><Value>{hasGetUserMedia ? 'True' : 'False'}</Value>
          <Label>DataChannel</Label><Value>{hasDataChannel ? 'True' : 'False'}</Value>
        </Table>
        <div>
          <h3>Feature Settings</h3>
          <pre>{JSON.stringify(features, null, 2)}</pre>
        </div>
      </Wrap>
    </Root>
  );
}

const Root = styled.div({
  height: `calc(100vh - var(--navbar-height))`,
  width: '100%',
});

const Wrap = styled.div({
  boxSizing: 'border-box',
  padding: '20px',
  margin: '0 auto',
  maxWidth: '750px',
});

const Table = styled.div({
  display: 'grid',
  gridTemplateColumns: '225px 1fr',
  rowGap: '6px',
});

const Label = styled.div(({ theme }) => ({
  fontFamily: theme.fonts.semiBold,
}));

const Value = styled.div({
  wordBreak: 'break-all',
});